import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion';
import { FaIdCard, FaUser } from 'react-icons/fa';
import { useAuth } from '../../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';


export default function GrupoFamiliar() {
    const navigate = useNavigate();
    const { token, rol } = useAuth();
    const { idPersona } = useParams();
    const [personas, setPersonas] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false);
    const [idCabezaFamilia, setIdCabezaFamilia] = useState(0);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
        });
    };
    useEffect(() => {
        const fetchData = async () => {
          const url = '/caracterizacion/consultarGrupoFamiliar';
          const obj = {idPersona: idPersona}
          try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setPersonas(result);
            setIdCabezaFamilia(result[0].gru_idcabezafamilia);
          } catch (error) {
            Mensaje('Error', error.response ? error.response.data.message : 'Error al cargar los datos');
            console.error('Error fetching data:', error);
          } finally {
            setCargando(false);
          }
        };
    
        fetchData();
      }, [idPersona, token]);
    function handleEdit (row){
        navigate(`/caracterizacion/persona/${row.id}/${row.per_idpersona}/${row.gru_idcabezafamilia}`);
    };
    function handleEditDocumento (row){
        navigate(`/caracterizacion/personaeditdocumento/${row.id}/${row.per_idpersona}/${row.gru_idcabezafamilia}`);
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Grupo familiar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Grupo familiar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <div className='card'>
                        <div className="card-header">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 text-end">
                                        <NavLink to={`/caracterizacion/persona/0/0/${idCabezaFamilia}`}>
                                            <button type="button" className="btn btn-primary">
                                                <FaUser/> Nuevo integrante
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Documento</th>
                                            <th>Nombre</th>
                                            <th>Edad</th>
                                            <th>Parentesco</th>
                                            <th>Usuario</th>
                                            <th>Fallecido</th>
                                            <th>Retornado</th>
                                            <th>DX</th>
                                            <th>SSV</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {personas.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            personas.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>
                                                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleEdit(row)}
                                                                style={{
                                                                    backgroundColor: 'skyblue',
                                                                    padding: '12px 20px',
                                                                    fontSize: '1.5rem',
                                                                    borderRadius: '8px',
                                                                    border: 'none',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: 'black'
                                                                }}
                                                                data-tooltip-id='tooltiparriba'
                                                                data-tooltip-content="Ver datos de la persona"
                                                            >
                                                                <FaUser />
                                                            </button>
                                                            {rol === '2' && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleEditDocumento(row)}
                                                                    style={{
                                                                        backgroundColor: 'skyblue',
                                                                        padding: '12px 20px',
                                                                        fontSize: '1.5rem',
                                                                        borderRadius: '8px',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        color: 'black'
                                                                    }}
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Editar documento"
                                                                >
                                                                    <FaIdCard />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.per_idpersona}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.nombre}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.edad}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.par_parentesco}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.usuario}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.per_fallecido}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.retornado}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.dx}</td>
                                                    <td style={{ fontSize: '1.1rem' }}>{row.ssv}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    )
}